const routes = {
  home: { title: 'routes.home', url: '/' },
  contentBankCategories: {
    title: 'routes.contentBank',
    url: '/content-bank-categories',
  },
  contentBankSubCategory: {
    title: 'routes.contentBank',
    url: '/content-bank-categories/[id]',
    href: (ids: string[]): string =>
      `/content-bank-categories/${ids.join('/')}`,
  },
  contentBankCategory: {
    title: 'routes.contentBank',
    url: '/content-bank-category/[id]',
    href: (id: string): string => `/content-bank-category/${id}`,
  },
  content: {
    title: 'routes.contentBank',
    url: '/content-bank/[id]',
    href: (id: string): string => `/content-bank/${id}`,
  },
  profile: { title: 'routes.profile', url: '/profile' },
  dashboard: { title: 'routes.dashboard', url: '/' },
  bookmarks: { title: 'routes.bookmarks', url: '/bookmarks' },
  bookmark: {
    url: '/bookmarks/[id]',
    href: (id: string): string => `/bookmarks/${id}`,
  },
  lessons: { title: 'routes.lessons', url: '/lessons' },
  lesson: {
    title: 'routes.lesson',
    url: '/lessons/[id]',
    href: (id: string): string => `/lessons/${id}`,
  },
};

export default routes;
